import {
    post
} from './request'

/** 党建工作分类列表页 */
export const getCategoryList = data => post('/index/dj_cate_list', data)
// 党建工作类目文章列表页
export const getPage = data => post('/index/dj_cate_article_list', data)
// 党建工作详情页
export const getOne = data => post('/index/dj_article_detail', data)